module.exports = __webpack_public_path__ + "img/Cristopher_Paniagua.6a94f729.jpg";